"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _uiBox = _interopRequireDefault(require("ui-box"));

var UnorderedList =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(UnorderedList, _PureComponent);

  function UnorderedList() {
    (0, _classCallCheck2.default)(this, UnorderedList);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(UnorderedList).apply(this, arguments));
  }

  (0, _createClass2.default)(UnorderedList, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          size = _this$props.size,
          icon = _this$props.icon,
          iconColor = _this$props.iconColor,
          props = (0, _objectWithoutProperties2.default)(_this$props, ["children", "size", "icon", "iconColor"]); // Only pass down icon-related props if specified

      var inheritedProps = icon ? {
        size: size,
        icon: icon,
        iconColor: iconColor
      } : {
        size: size
      };

      var finalChildren = _react.default.Children.map(children, function (child) {
        if (!_react.default.isValidElement(child)) {
          return child;
        }

        return _react.default.cloneElement(child, (0, _objectSpread2.default)({}, inheritedProps, child.props));
      });

      return _react.default.createElement(_uiBox.default, (0, _extends2.default)({}, UnorderedList.styles, props), finalChildren);
    }
  }]);
  return UnorderedList;
}(_react.PureComponent);

exports.default = UnorderedList;
UnorderedList.displayName = "UnorderedList";
(0, _defineProperty2.default)(UnorderedList, "propTypes", (0, _objectSpread2.default)({}, _uiBox.default.propTypes, {
  /**
   * Size of the text used in a list item.
   * Can be: 300, 400, 500, 600.
   */
  size: _propTypes.default.oneOf([300, 400, 500, 600]).isRequired,

  /**
   * When passed, adds a icon before each list item in the list
   * You can override this on a individual list item.
   */
  icon: _propTypes.default.string,

  /**
   * The color of the icon in each list item in the list.
   */
  iconColor: _propTypes.default.string
}));
(0, _defineProperty2.default)(UnorderedList, "defaultProps", {
  size: 400
});
(0, _defineProperty2.default)(UnorderedList, "styles", {
  is: 'ul',
  margin: 0,
  marginLeft: '1.1em',
  padding: 0,
  listStylePosition: 'inside',
  listStyle: 'disc'
});
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


//////////////////
// WEBPACK FOOTER
// ./~/evergreen-ui/commonjs/typography/src/UnorderedList.js
// module id = 278
// module chunks = 0